import { BLUE_GREY_200, BLUE_GREY_400, LILAC_400, LILAC_800 } from '../colors';
var scrollableConfig = {
  variant: 'scrollView',
  horizontalScroll: false,
  scrollIndicatorSize: 8,
  scrollTrackColor: LILAC_400,
  scrollThumbColor: LILAC_800
};
var whiteTheme = {
  variant: 'scrollView',
  horizontalScroll: false,
  scrollIndicatorSize: 8,
  scrollTrackColor: BLUE_GREY_200,
  scrollThumbColor: BLUE_GREY_400
};
export default {
  light: scrollableConfig,
  dark: scrollableConfig,
  white: whiteTheme
};